import React, { useEffect, useState } from "react";
import _ from "lodash";
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table";
import { useLocation } from "react-router";
import GetAppIcon from "@material-ui/icons/GetApp";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {
  createStyles,
  Grid,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import {
  HeaderCellSort,
  useSort,
} from "@table-library/react-table-library/sort";
import "jspdf-autotable";
import { Icon } from "@iconify/react";

import { CustomTheme } from "../../../../types/customTheme";
import CardCommon from "../../../../components/card/CardCommon";
import MenuButtonCommon from "../../../../components/buttons/MenuButtonCommon";
import { handleDownloadCsv } from "./convertPdfExcel/convertDataToExcel";
import {
  sortDatesTime,
  sortNumbers,
  sortStrings,
} from "../../../../utils/commonArrayMap";
import LocationDetailsCard from "../../../../components/common/LocationDetailsCard";
import { getLocalStore } from "../../../../utils/store/localStore";
import { convertDateTimeFormat } from "../../../../utils/ConvertDateTimeFormat";
import { handleDownloadPdf } from "./convertPdfExcel/convertDataToPdf";

export interface PaymentReportInfoNodeProps {
  rewardRedeemedNodeList: any;
  locationSelectorList: any;
  filterDetails: any;
  filterData: any;
  basedOnShift: any;
  locationSelectedList: any;
  handleOnClickText: any;
  rewardNode: any;
}

const useStyles = (nodesLength: number, bodyLength: number) =>
  makeStyles((theme: CustomTheme) =>
    createStyles({
      startTextStyle: {
        fontWeight: "bold",
        display: "flex",
        justifyContent: "start",
        paddingLeft: "16px",
        fontSize: "12px",
      },
      hiddenScroll: {
        // 1. For Webkit (Chrome, Safari, Edge)
        "&::-webkit-scrollbar": {
          height: "1px", // Set a smaller height for the horizontal scrollbar (e.g., 5px)
          backgroundColor: "transparent", // Make the track background transparent
        },

        // Style the actual draggable part (the thumb)
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0, 0, 0, 0.3)", // Subtle dark color for the thumb
          borderRadius: 1, // Make the thumb rounded
        },

        // 2. For Firefox
        scrollbarWidth: "thin", // Makes the scrollbar less intrusive
        // This defines the color of the thumb (first value) and the track (second value)
        scrollbarColor: `${theme.palette.background.entity_highlight_background_current_footer} transparent`,
      },
      textStyleHeader: {
        display: "flex",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: "12px",
      },
      endTextStyle: {
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        fontSize: "12px",
        paddingRight: "20px",
      },
      headerEndTextStyle: {
        display: "flex",
        fontWeight: "bold",
        justifyContent: "end",
        fontSize: "12px",
        paddingRight: "16px",
      },
      textStyle: {
        display: "flex",
        justifyContent: "center",
        fontSize: "12px",
      },
      headerStyle: {
        "&:last-of-type": {
          backgroundColor: theme.palette.background.table_header_background,
          color: theme.palette.custom.orange.contrastText,
        },
      },
      finalTotalRow: {
        cursor: "pointer",
        height: "40px",
        [`&:nth-of-type(${bodyLength + 1})`]: {
          color: theme.palette.custom["green"].contrastText,
          backgroundColor: theme.palette.custom.green.main,
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: theme.palette.custom.green.light,
          },
        },
      },
      totalRow: {
        cursor: "pointer",
        "&.css-16gtl2w": {
          display: "flex",
          justifyContent: "center",
        },
        "&:nth-of-type(n)": {
          color: theme.palette.custom["green"].contrastText,
          backgroundColor: theme.palette.custom.green.main,
          "&:hover": {
            backgroundColor: theme.palette.custom.green.light,
          },
        },
      },
      headerRow: {
        fontSize: "13px",
        cursor: "pointer",
        "&.css-16gtl2w": {
          display: "flex",
          justifyContent: "center",
        },
        "&:nth-of-type(odd)": {
          backgroundColor: theme.palette.background.paper,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
        "&:nth-of-type(even)": {
          backgroundColor: theme.palette.background.entity_background,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
      baseCellRow: {
        placeItems: "center",
        "& .css-16gtl2w": {
          fontWeight: "bold",
        },
        height: "40px",
        "&:nth-of-type(1)": {
          left: "0px",
          minWidth: `${100 / 6}%`,
          width: `${100 / 6}%`,
        },
        [theme.breakpoints.down("xl")]: {
          [`&:nth-of-type(n+2):nth-of-type(-n+${5})`]: {
            minWidth: `${100 / 6}%`,
            width: `${100 / 6}%`,
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "center",
              fontWeight: "bold",
            },
          },
          [`&:nth-of-type(${6})`]: {
            minWidth: `${100 / 6}%`,
            width: `${100 / 6}%`,
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "end",
              fontWeight: "bold",
              paddingRight: "16px",
            },
          },
        },
        [theme.breakpoints.down("lg")]: {
          [`&:nth-of-type(n+2):nth-of-type(-n+${5})`]: {
            minWidth: `20%`,
            width: `20%`,
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "center",
              fontWeight: "bold",
            },
          },
          [`&:nth-of-type(${6})`]: {
            minWidth: `20%`,
            width: `20%`,
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "end",
              fontWeight: "bold",
              paddingRight: "16px",
            },
          },
          "&:nth-of-type(1)": {
            left: "0px",
            minWidth: "20%",
            width: "20%",
          },
        },
        [theme.breakpoints.down("xs")]: {
          [`&:nth-of-type(n+2):nth-of-type(-n+${5})`]: {
            minWidth: "20%",
            width: "20%",
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "center",
              fontWeight: "bold",
            },
          },
          [`&:nth-of-type(${6})`]: {
            minWidth: "20%",
            width: "20%",
            "& .css-16gtl2w": {
              display: "flex",
              justifyContent: "end",
              fontWeight: "bold",
              paddingRight: "16px",
            },
          },
          "&:nth-of-type(1)": {
            left: "0px",
            minWidth: "20%",
            width: "20%",
          },
        },
      },
    }),
  );

/**
 * PaymentReportInfoNode Component
 *
 * This component renders a table displaying payment report data.
 * It also provides options to export the report as PDF or CSV.
 * Users can view sale details by clicking on items in the table.
 */
const PaymentReportInfoNode: React.FunctionComponent<
  PaymentReportInfoNodeProps
> = ({
  rewardRedeemedNodeList,
  locationSelectorList,
  filterDetails,
  filterData,
  basedOnShift,
  locationSelectedList,
  handleOnClickText,
  rewardNode,
}) => {
  const [pdfHeaders, setPdfHeaders] = useState<any>([]);
  const [headersList, setHeadersList] = useState<any>([]);
  const [excelHeaders, setExcelHeaders] = useState<any>([]);
  const [nodes, setNodes] = useState<any>({ nodes: [] });
  const [nodesPdfExcel, setNodesPdfExcel] = useState<any>([]);
  const [footer, setFooter] = useState<any>([]);
  const [nodesLength, setNodeLength] = useState(0);
  const [bodyLength, setBodyLength] = useState(0);
  const [locationsLength, setLocationsLength] = useState(0);
  const [openSaleDetailsModal, setOpenSaleDetailsModal] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [cloneFilterData, setCloneFilterData] = useState("");

  const maxWidth = useMediaQuery("(max-width: 1600px)");
  const maxWidthCustom = useMediaQuery("(max-width: 1600px)");
  const open = Boolean(anchorEl);
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  useEffect(() => {
    setNodes({ nodes: [] });
  }, [params.get("startDate")]);

  /* Creating the data for the Payment report table and creating the data for pdf and excel files.
       Using a API request */
  useEffect(() => {
    let cloneRewardRedeemedNodeList: any = _.cloneDeep(rewardRedeemedNodeList);
    let footer: any = [];

    if (!_.isEmpty(cloneRewardRedeemedNodeList) && !_.isEmpty(rewardNode)) {
      // ✅ Build the reward order list based on rewardNode keys (to preserve defined order)
      const rewardOrder = Object.keys(rewardNode);

      // ✅ Ensure all rewards exist in the clone list (even if 0 values)
      rewardOrder.forEach((rewardId) => {
        const exists = cloneRewardRedeemedNodeList.some(
          (item: any) => item.rewardId === rewardId,
        );
        if (!exists) {
          cloneRewardRedeemedNodeList.push({
            rewardId,
            timesRedeemed: 0,
            totalRewardCost: 0,
            uniqueCustomersRedeemed: 0,
            firstRedemption: "-",
            lastRedemption: "-",
          });
        }
      });

      // ✅ Sort by the order of rewardNode
      cloneRewardRedeemedNodeList.sort(
        (a: any, b: any) =>
          rewardOrder.indexOf(a.rewardId) - rewardOrder.indexOf(b.rewardId),
      );

      // ✅ Replace rewardId with the title, keeping data intact
      cloneRewardRedeemedNodeList = cloneRewardRedeemedNodeList
        .filter((item: any) => item.rewardId && rewardNode[item.rewardId])
        .map((item: any) => ({
          ...item,
          rewardId: rewardNode[item.rewardId].title,
        }));

      // ✅ Calculate footer
      footer = cloneRewardRedeemedNodeList.reduce(
        (acc: any, curr: any) => {
          acc.timesRedeemed += curr.timesRedeemed;
          acc.totalRewardCost += curr.totalRewardCost;
          acc.uniqueCustomersRedeemed += curr.uniqueCustomersRedeemed;
          return acc;
        },
        {
          rewardId: "Total",
          timesRedeemed: 0,
          totalRewardCost: 0,
          uniqueCustomersRedeemed: 0,
          firstRedemption: "",
          lastRedemption: "",
        },
      );

      footer.totalRewardCost = parseFloat(footer.totalRewardCost).toFixed(2);

      // ✅ Example: set headers, footer, etc. (same as before)
      setHeadersList([
        "Reward",
        "Times Redeemed",
        "Total Reward Cost",
        "Unique Customers",
        "First Redemption",
        "Last Redemption",
      ]);

      setPdfHeaders([
        { title: "Reward", field: "rewardId" },
        { title: "Times Redeemed", field: "timesRedeemed" },
        { title: "Total Reward Cost", field: "totalRewardCost" },
        { title: "Unique Customers", field: "uniqueCustomersRedeemed" },
        { title: "First Redeemed", field: "firstRedemption" },
        { title: "Last Redeemed", field: "lastRedemption" },
      ]);

      setExcelHeaders([
        {
          header: "Reward",
          key: "rewardId",
          width: 52,
          height: 68,
        },

        {
          header: "Times Redeemed",
          key: "timesRedeemed",
          width: 32,
          height: 68,
        },
        {
          header: "Total Reward Cost",
          key: "totalRewardCost",
          width: 32,
          height: 68,
        },
        {
          header: "Unique Customers",
          key: "uniqueCustomersRedeemed",
          width: 32,
          height: 68,
        },
        {
          header: "First Redeemed",
          key: "firstRedemption",
          width: 52,
          height: 68,
        },
        {
          header: "Last Redeemed",
          key: "lastRedemption",
          width: 32,
          height: 68,
        },
      ]);

      setNodeLength(cloneRewardRedeemedNodeList.length - 1);
      setBodyLength(cloneRewardRedeemedNodeList.length);
      setNodes({ nodes: cloneRewardRedeemedNodeList });
      setFooter(footer);
      setNodesPdfExcel([...cloneRewardRedeemedNodeList, footer]);
    }
  }, [rewardRedeemedNodeList, rewardNode]);
  // Create a pay In Out sorting function
  const sort = useSort(
    nodes,
    {},
    {
      sortFns: {
        Reward: (array) => sortStrings(array, "rewardId"),
        "First Redemption": (array) => sortDatesTime(array, "firstRedemption"),
        "Last Redemption": (array) => sortDatesTime(array, "lastRedemption"),
        "Times Redeemed": (array) => sortNumbers(array, "timesRedeemed"),
        "Total Reward Cost": (array) => sortNumbers(array, "totalRewardCost"),
        "Unique Customers": (array) =>
          sortNumbers(array, "uniqueCustomersRedeemed"),
      },
      sortIcon: {
        margin: "0px",
        iconDefault: (
          <Icon
            icon="fluent:chevron-up-down-16-filled"
            width="44"
            height="44"
          />
        ),
        iconUp: <ArrowDropDownIcon />,
        iconDown: <ArrowDropUpIcon />,
      },
    },
  );

  /* Open PDF / Excel selection menu */
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  /* Close PDF / Excel selection menu */
  const handleClose = () => {
    setAnchorEl(null);
  };

  const maxWidthLocationChips = useMediaQuery("(max-width: 600px)");
  const theme: CustomTheme = useTheme();
  const classes: any = useStyles(nodesLength, bodyLength)();

  return (
    <>
      <Grid
        container
        style={{
          marginBottom: "20px",
          marginTop: "8px",
        }}
      >
        <Grid item xs={12}>
          <div
            style={
              maxWidthLocationChips
                ? { display: "block" }
                : {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }
            }
          >
            <LocationDetailsCard
              locationSelectedList={locationSelectedList}
              handleOnClickText={handleOnClickText}
            />
            {!_.isEmpty(nodes.nodes) && (
              <div
                style={
                  maxWidthLocationChips
                    ? {
                        display: "flex",
                        justifyContent: "end",
                        marginTop: "8px",
                      }
                    : { marginLeft: "16px" }
                }
              >
                <MenuButtonCommon
                  id="basic-button"
                  variant="contained"
                  style={{
                    fontSize: 11,
                    height: "38px",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                  }}
                  color="blue"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <GetAppIcon />
                  <Typography
                    variant="body1"
                    style={{ paddingLeft: "16px", color: "white" }}
                  >
                    Export
                  </Typography>
                </MenuButtonCommon>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  PaperProps={{
                    elevation: 0,
                    style: {
                      borderRadius: "10px",
                      border: `1px solid ${theme.palette.background.entity_border}`,
                    },
                  }}
                  style={{ top: "56px" }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      handleDownloadPdf(
                        "p",
                        pdfHeaders,
                        nodesPdfExcel,
                        filterDetails,
                        bodyLength,
                      );
                      handleClose();
                    }}
                  >
                    Export as PDF
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleDownloadCsv(
                        excelHeaders,
                        nodesPdfExcel,
                        filterDetails,
                        bodyLength,
                      );
                      handleClose();
                    }}
                  >
                    Export as CSV
                  </MenuItem>
                </Menu>
              </div>
            )}
          </div>
        </Grid>
      </Grid>

      <CardCommon>
        <Table
          data={nodes}
          sort={sort}
          layout={{ custom: maxWidthCustom, horizontalScroll: maxWidth }}
          className={classes.hiddenScroll}
        >
          {(tableList) => (
            <>
              <Header style={{ zIndex: 0 }}>
                <HeaderRow className={classes.headerStyle}>
                  {headersList.map(
                    (data: any, index: any) =>
                      data !== "rewardId" && (
                        <HeaderCellSort
                          sortKey={data}
                          pinLeft={index === 0 ? true : false}
                          className={classes.baseCellRow}
                          style={{ paddingRight: "4px" }}
                        >
                          <Typography
                            variant="caption"
                            className={
                              index === 0
                                ? classes.startTextStyle
                                : index === 7
                                ? classes.headerEndTextStyle
                                : classes.textStyleHeader
                            }
                            style={{
                              color: theme.palette.custom.orange.contrastText,
                            }}
                          >
                            {data}
                          </Typography>
                        </HeaderCellSort>
                      ),
                  )}
                </HeaderRow>
              </Header>

              <Body className={classes.bodyStyle}>
                {tableList.map((item, bodyIndex) => (
                  <>
                    <Row
                      key={item.gross20}
                      item={item}
                      className={
                        item.Method === "Total Payments"
                          ? classes.totalRow
                          : classes.headerRow
                      }
                    >
                      <Cell pinLeft={true} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.startTextStyle}
                        >
                          {item["rewardId"]}
                        </Typography>
                      </Cell>

                      <Cell pinLeft={false} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.textStyle}
                        >
                          {item["timesRedeemed"]}
                        </Typography>
                      </Cell>
                      <Cell pinLeft={false} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.textStyle}
                        >
                          {item["totalRewardCost"]}
                        </Typography>
                      </Cell>

                      <Cell pinLeft={false} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.textStyle}
                        >
                          {item["uniqueCustomersRedeemed"]}
                        </Typography>
                      </Cell>
                      <Cell pinLeft={false} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.textStyle}
                        >
                          {item["firstRedemption"] &&
                          item["firstRedemption"] !== "-"
                            ? convertDateTimeFormat(item["firstRedemption"])
                            : "-"}
                        </Typography>
                      </Cell>
                      <Cell pinLeft={false} className={classes.baseCellRow}>
                        <Typography
                          variant="caption"
                          align="left"
                          className={classes.endTextStyle}
                        >
                          {item["lastRedemption"] &&
                          item["lastRedemption"] !== "-"
                            ? convertDateTimeFormat(item["lastRedemption"])
                            : "-"}
                        </Typography>
                      </Cell>
                    </Row>
                    {bodyIndex + 1 === tableList.length && (
                      <>
                        <Row
                          className={classes.finalTotalRow}
                          key={footer.firstRedemption}
                          item={footer}
                        >
                          <Cell pinLeft={true} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.startTextStyle}
                            >
                              {footer["rewardId"]}
                            </Typography>
                          </Cell>

                          <Cell pinLeft={false} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.textStyle}
                            >
                              {footer["timesRedeemed"]}
                            </Typography>
                          </Cell>
                          <Cell pinLeft={false} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.textStyle}
                            >
                              {footer["totalRewardCost"]}
                            </Typography>
                          </Cell>

                          <Cell pinLeft={false} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.textStyle}
                            >
                              {footer["uniqueCustomersRedeemed"]}
                            </Typography>
                          </Cell>
                          <Cell pinLeft={false} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.textStyle}
                            >
                              {footer["firstRedemption"]}
                            </Typography>
                          </Cell>

                          <Cell pinLeft={false} className={classes.baseCellRow}>
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: "bold",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                              }}
                              className={classes.endTextStyle}
                            >
                              {footer["lastRedemption"]}
                            </Typography>
                          </Cell>
                        </Row>
                      </>
                    )}
                  </>
                ))}
              </Body>
            </>
          )}
        </Table>
      </CardCommon>
    </>
  );
};

export default PaymentReportInfoNode;
